export function sum(acc: number, next: number) {
    return acc + next;
}

export function flatMap<T>(acc: Array<T>, next: Array<T>): Array<T> {
    return acc.concat(next);
}

export function distinct<T>(value: T, index: number, arr: Array<T>): boolean {
    return arr.indexOf(value) === index;
}

export function ascending(a: number, b: number): number {
    if (a < b) {
        return -1;
    } else if (a > b) {
        return 1;
    } else {
        return 0;
    }
}

export function descending(a: number, b: number): number {
    if (a < b) {
        return 1;
    } else if (a > b) {
        return -1;
    } else {
        return 0;
    }
}

export function isNotNull<T>(value: T | undefined | null): value is T {
    return value != null;
}

export function identity<T>() {
    return (val: T) => val;
}

export function noop(...args: Array<any>) {
    return () => {};
}

export function Pair<L, R>(left: L, right: R): [L, R] {
    return [left, right];
}

type BooleanFunction = (...args: Array<any>) => boolean

export function not(fn: BooleanFunction): BooleanFunction {
    return (args) => !fn(args)
}
